<template>
  <section>
    <b-modal
      :active.sync="isActive"
      has-modal-card
      trap-focus
      aria-role="dialog"
      aria-modal
    >
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">{{$t("misc.downloads")}}</p>
        </header>
        <section class="modal-card-body">
          <div class="download-options">
            <div class="download-item" @click="goToURL('https://cyberfoxguard.com/downloads/CFGBrowserWIN.zip')">
              <img src="/img/logos/windows.svg" alt="Windows" class="platform-logo">
              <div class="platform-name">Windows</div>
            </div>
            
            <div class="download-item" @click="goToURL('https://cyberfoxguard.com/downloads/CFGBrowserARM.dmg')">
              <img src="/img/logos/apple.svg" alt="Apple ARM" class="platform-logo">
              <div class="platform-name">Apple ARM</div>
            </div>
            
            <div class="download-item" @click="goToURL('https://cyberfoxguard.com/downloads/CFGBrowserIntel.zip')">
              <img src="/img/logos/apple.svg" alt="Apple Intel" class="platform-logo">
              <div class="platform-name">Apple Intel</div>
            </div>
            
            <div class="download-item" @click="goToURL('https://chromewebstore.google.com/detail/cyberfox-guard/caffjegifhpcfocplockmdgmhmdmjkbf')">
              <img src="/img/logos/cfg-extension.svg" alt="Extension" class="platform-logo">
              <div class="platform-name">{{$t("misc.extension")}}</div>
            </div>
          </div>

          <hr class="separator" />
          <div class="download-options-mobile">
            <div class="download-item" @click="goToURL('https://apps.apple.com/gb/app/cyberfox-guard/id6741487287')">
              <img src="/img/qrcodes/CFG_iOS.svg" alt="Apple iOS" class="platform-qr">
              <div class="platform-name">iOS</div>
            </div>
            <div class="div-spacer"></div>              
            <div class="download-item" @click="goToURL('https://play.google.com/store/apps/details?id=com.cyberfoxguard.app')">
              <img src="/img/qrcodes/CFG_Android.svg" alt="Android" class="platform-qr">
              <div class="platform-name">Android</div>
            </div>           

          </div>
        </section>
        <footer class="modal-card-foot">
          <b-button type="is-dark" @click="close()">
           {{$t("btn.close")}}
          </b-button>
        </footer>
      </div>
    </b-modal>
  </section>
</template>

<script>
export default {
  name: "Install",
  methods: {
    close() {
      this.$store.commit('hideModal', 'install');
    },
    goToURL(link){
      window.location.href = link;
    },
  },
  computed: {
    isActive: {
      get: function() {
        return this.$store.state.modals.install;
      },
      // setter
      set: function() {
        this.$store.commit('hideModal', 'install');
        return false;
      }
    }
  }
};
</script>
<style scoped>
.modal-card-foot {
  justify-content: center;
}

.download-options {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.download-options-mobile {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;

}

.separator{
    background-color: #383838;
    border: none;
    display: block;
    height: 2px;
    margin: 1.5rem 0;
}

.div-spacer{
  width: 20px;
}

.download-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 15px;
  border-radius: 8px;
  border: 1px solid #363636;
  cursor: pointer;
  transition: all 0.3s ease;
  width: 22%;
}

.download-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  border-color: #e7e7e7;
}

.platform-logo {
  width: 60px;
  height: 60px;
  margin-bottom: 10px;
}

.platform-qr {
  width: 100px;
  height: 100px;
  margin-bottom: 10px;
}

.platform-name {
  font-weight: bold;
  font-size: 1rem;
  color: #e0e0e0;
}
</style>
